<template>
  <div :style="{ position: 'relative' }">
    <Loading
      :active.sync="loading"
      :isFullPage="false"
      :zIndex="9000"
    ></Loading>
    <Dialog
      id="'dialog-recolha-reception'"
      :visible.sync="show"
      :style="{ width: $isMobile() ? '100vw' : '50vw' }"
      v-bind:class="[{ 'p-dialog-maximized': $isMobile() }]"
      :modal="true"
      :header="'Recepção do Equipamento'"
      @hide="$emit('close')"
    >
      <div class="p-grid p-formgrid">
        <div class="p-field p-col-12 p-md-4">
          <label>Data de Chegada</label>
          <Calendar
            v-model="form.arrivalDate"
            dateFormat="dd/mm/yy"
            :showIcon="true"
            :disabledDays="[0, 6]"
            inputClass="p-inputtext-sm"
            class="w-full"
          />
        </div>
      </div>
      <div class="p-grid p-formgrid">
        <div class="p-field p-col-12 p-md-6">
          <label>Estado Físico</label>
          <Textarea
            v-model="form.physicalCondition"
            rows="4"
            class="p-inputtext-sm w-full"
          />
        </div>

        <div class="p-field p-col-12 p-md-6">
          <label>OUTROS ACESSORIOS</label>
          <Textarea
            v-model="form.otherAccessories"
            rows="4"
            class="p-inputtext-sm w-full"
          />
        </div>

        <div class="p-col-12">
          <div class="acessorios-grid">
            <div
              v-for="acc in accessoryOptions"
              :key="acc.code"
              class="p-d-flex p-ai-center"
            >
              <Checkbox
                :inputId="'cb-' + acc.code"
                v-model="form.accessories[acc.code]"
                :binary="true"
              />
              <label
                :for="'cb-' + acc.code"
                class="p-ml-2 cb-label"
                @click="$set(form.accessories, acc.code, !form.accessories[acc.code])"
              >{{ acc.name }}</label>
            </div>
          </div>
        </div>
      </div>

      <template #footer>
        <Button
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-text"
          @click="$emit('close')"
        />
        <Button
          label="Guardar"
          icon="pi pi-check"
          class="p-button-success"
          :loading="loading"
          @click="saveReception"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import supportService from "../../services/support.service";
import ReceptionAccessoryService from "../../services/reception-accessory.service";

const emptyForm = (accessoryOptions = []) => {
  const accessories = {};
  accessoryOptions.forEach((acc) => {
    accessories[acc.code] = false;
  });
  return {
    arrivalDate: new Date(),
    arrivalTime: new Date(),
    physicalCondition: "",
    otherAccessories: "",
    accessories,
  };
};

export default {
  name: "PickupReception",
  components: {
    Loading,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    service: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      form: emptyForm(),
      accessoryOptions: [],
    };
  },
  watch: {
    show(val) {
      if (val) {
        this.loadData();
      } else {
        this.form = emptyForm(this.accessoryOptions);
      }
    },
  },
  methods: {
    async loadData() {
      try {
        this.loading = true;
        const accResponse = await ReceptionAccessoryService.getAll()

        this.accessoryOptions = accResponse?.data || accResponse || [];
        this.form = emptyForm(this.accessoryOptions);
      } catch {
        this.$toast.add({
          severity: "error",
          summary: "Erro",
          detail: "Erro ao carregar dados da recepção.",
          life: 3000,
        });
      } finally {
        this.loading = false;
      }
    },
    formatDate(date) {
      if (!date) return null;
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    buildPayload() {
      return {
        arrival_date: this.formatDate(this.form.arrivalDate),
        physical_condition: this.form.physicalCondition,
        other_accessories: this.form.otherAccessories,
        accessories: this.form.accessories
      };
    },
    async saveReception() {
      if (!this.service || !this.service.id) {
        return;
      }

      try {
        this.loading = true;
        const payload = this.buildPayload();
        await supportService.saveReception(this.service.id, payload);

        this.$toast.add({
          severity: "success",
          summary: "Sucesso",
          detail: "Recepção registada com sucesso.",
          life: 3000,
        });

        this.$emit("savedReception");
      } catch {
        this.$toast.add({
          severity: "error",
          summary: "Erro",
          detail: "Erro ao guardar recepção.",
          life: 3000,
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.acessorios-grid {
  display: grid;
  grid-template-columns: repeat(6, auto);
  gap: 0.5rem 1.5rem;
  padding: 0.5rem 0;
}

.acessorios-grid label {
  cursor: pointer;
}

.cb-label {
  cursor: pointer;
  user-select: none;
}

.w-full {
  width: 100%;
}

@media (max-width: 768px) {
  .acessorios-grid {
    grid-template-columns: repeat(2, auto);
    gap: 0.5rem 1rem;
  }
}

@media (max-width: 480px) {
  .acessorios-grid {
    grid-template-columns: 1fr;
  }
}
</style>
